import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { CheckboxGroup, CheckboxWithText } from 'components'
import {
  formatObjectsToIds,
  isOtherType,
  parseIdsToObjects,
  serializeOptions,
  yankBy,
} from 'utils'

const propTypes = {
  outcomeTypes: PropTypes.array.isRequired,
  prefix: PropTypes.string,
}

function PartnerOutcomeTypeForm({ outcomeTypes, prefix = '' }) {
  const [otherOutcomeType, definedOutcomeTypes] = useMemo(
    () => yankBy(outcomeTypes, isOtherType),
    [outcomeTypes]
  )

  const base = prefix ? `${prefix}.` : ''

  return (
    <div>
      <Field
        name={`${base}requestedOutcomeTypes`}
        label={false}
        component={CheckboxGroup}
        format={formatObjectsToIds('outcomeTypeId')}
        parse={parseIdsToObjects('outcomeTypeId')}
        options={serializeOptions(definedOutcomeTypes)}
      />
      {otherOutcomeType && (
        <Field
          name={`${base}otherText`}
          label={otherOutcomeType.displayName}
          placeholder="Description..."
          component={CheckboxWithText}
        />
      )}
    </div>
  )
}

PartnerOutcomeTypeForm.propTypes = propTypes

export default PartnerOutcomeTypeForm
